import { SharedObject } from 'expo';
//# sourceMappingURL=VideoPlayer.types.js.map